import React, { Component } from "react";
import Dialog from "./../UiComponents/Dialog";
import PropTypes from "prop-types";
import Logo from "./../UiComponents/Logo";
import simIcon from "./../../globals/images/logo.svg";
import urlConsts from "./../../constants/urls";
import getLabel from './../../utils/labels'
import styles from "./endScreen.module.scss";
import analyticsUtil from "../../utils/segmentUtils";

class Confirmation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDownloadButtonReady: true,
            buttonDisabledStyle: {
                cursor: "default"
            }
        };
    }

    logout = () => {
        let logoutUrl = (this.props.logoutType === 'NORMAL') ? urlConsts.LOGOUT_URL : urlConsts.RETURN_URL
        analyticsUtil.reset();
        window.location = logoutUrl
    };

    downloadReport = () => {
        // temporarily disable download button
        if (this.state.isDownloadButtonReady) {
            this.setState({
                isDownloadButtonReady: false
            });
            this.props.downloadReport().then(response => {
                window.location = response.url;

                //enable download reprot button after downloading starts
                this.setState({
                    isDownloadButtonReady: true
                });
            });
        }
    };

    render() {
        let { isDownloadButtonReady, buttonDisabledStyle } = this.state;

        return (
            <Dialog overlayClassName={styles.dialog} isFooterNeeded={false}>
                <div className={styles.container}>
                    <div className={styles.message}>
                        <Logo />
                        <div className={styles.boldtext}>
                            {getLabel('label_sim_ended_test')}
                        </div>
                        {/* <div className={styles.downloadButton}>
							{getLabel('label_download_report_text')}
							<div
								onClick={this.downloadReport}
								disabled={isDownloadButtonReady}
								className={styles["start-sim-button"]}
								style={
									!isDownloadButtonReady
										? buttonDisabledStyle
										: {}
								}
							>
								<div className={styles["button-text"]}>
									{
										isDownloadButtonReady ?
											getLabel('label_download_button')
											:
											getLabel('label_downloading_button') + '...'
									}
								</div>
							</div>
						</div>
						<div className={styles.fedtext}>
							<a href="https://docs.google.com/forms/d/e/1FAIpQLScliNnx8tfIJDaR51oPLc_8VDQBRykGNbBU6XuDSiqLzOkedg/viewform?usp=sf_link">
								{getLabel('label_share_feedback')}{" "}
							</a>
						</div> */}
                    </div>
                    <div className={styles.buttons}>
                        <div
                            className={styles.closeButton}
                            onClick={this.logout}
                        >
                            {(this.props.logoutType === 'NORMAL') ? getLabel('label_logout_button') : getLabel('label_return_button')}
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default Confirmation;



// WEBPACK FOOTER //
// /src/components/endScreen/EndScreen.js